export default "__VITE_ASSET__BRSslZpd__"